export default __webpack_public_path__ + "static/media/spots-canary-green.1349f64f.png";